import axios from "axios";
import {axiosCatchHandler} from "../sharedGlobal";

const state = {
  websiteAsCompetitor: null,
  competitors: [],
  suggestedCompetitors: [],
  serpSuggestedCompetitors: [],
  showSuggestedCompetitorsModal: false,
  showSerpSuggestedCompetitorsModal: false,
};

const getters = {
  suggestedCompetitors: ({suggestedCompetitors}) => suggestedCompetitors,
  serpSuggestedCompetitors: ({serpSuggestedCompetitors}) => serpSuggestedCompetitors,
  showSuggestedCompetitorsModal: ({showSuggestedCompetitorsModal}) => showSuggestedCompetitorsModal,
  showSerpSuggestedCompetitorsModal: ({showSerpSuggestedCompetitorsModal}) => showSerpSuggestedCompetitorsModal,
};

const mutations = {
  async setCompetitors(state, data){
    state.competitors = data;
  },
  async setSuggestedCompetitors(state, data){
    state.suggestedCompetitors = data;
  },
  async setSerpSuggestedCompetitors(state, data){
    state.serpSuggestedCompetitors = data;
  },
  async websiteAsCompetitor(state, competitor){
    state.websiteAsCompetitor = competitor;
  },
  setShowSuggestedCompetitorsModalState(state, modalState) {
    state.showSuggestedCompetitorsModal = modalState;
  },
  setShowSerpSuggestedCompetitorsModalState(state, modalState) {
    state.showSerpSuggestedCompetitorsModal = modalState;
  },
};

const actions = {
  async fetchData({dispatch}) {
    return new Promise(async (resolve, reject) => {
      await Promise.all([
          dispatch("fetchCompetitors"),
          dispatch("fetchSuggestedCompetitors"),
          dispatch("fetchSerpSuggestedCompetitors"),
        ])
        .then(() => {
          resolve();
        })
        .catch( (e) => {
          reject(e);
        });
    });
  },
  fetchCompetitors: ({commit}) =>
    axios.get('/ajax/competition/get-competitors')
      .then(({ data }) => commit('setCompetitors', data)),
  fetchWebsiteAsCompetitor: ({commit}, websiteId) =>
    axios.get(`/ajax/website/${websiteId}/as-competitor`)
      .then(({data}) => commit('websiteAsCompetitor', data)),
  fetchSuggestedCompetitors: ({commit}) =>
    axios.get('/ajax/competition/get-suggested-competitors')
      .then(({ data }) => commit('setSuggestedCompetitors', data)),
  fetchSerpSuggestedCompetitors: ({commit}) =>
    axios.get('/ajax/competition/get-serp-suggested-competitors')
      .then(({ data }) => commit('setSerpSuggestedCompetitors', data)),
  async addCompetitor({dispatch}, competitor_url){
    return new Promise(async (resolve, reject) => {
      axios.post('/ajax/competition/add-competitor', {
          competitor_url: competitor_url
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch(
          (e) => axiosCatchHandler(e, ({response}) => reject(response))
        );
    });
  },
  openSuggestedCompetitorsModal: ({commit}) => commit('setShowSuggestedCompetitorsModalState', true),
  closeSuggestedCompetitorsModal: ({commit}) => commit('setShowSuggestedCompetitorsModalState', false),
  openSerpSuggestedCompetitorsModal: ({commit}) => commit('setShowSerpSuggestedCompetitorsModalState', true),
  closeSerpSuggestedCompetitorsModal: ({commit}) => commit('setShowSerpSuggestedCompetitorsModalState', false),
};

const competition = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default competition;
